@if (multiSelect) {
	<td
		role="gridcell"
		class="library-tree-cell library-tree-cell-select"
		[attr.headers]="treeGridSelectHeaderId">
	</td>
}
<th
	scope="row"
	role="rowheader"
	class="library-tree-cell library-tree-cell-name"
	data-tree-cell="name"
	[attr.headers]="treeGridNameHeaderId"
	[attr.aria-labelledby]="getTreeGridNameLabelledBy()"
	[attr.tabindex]="treeGridNameTabindex"
	(focus)="emitTreeGridFocus('name')"
	(keydown)="emitTreeGridKeydown($event, 'name')">
	<div
		[attr.aria-label]="isTreeTableRowHost() ? null : getAriaLabel()"
		[attr.data-tree-node-key]="null"
		data-cy="collection-folder"
		(click)="expandFolder(folder)"
		class="library-folder-info">
		<i
			class="folder-icon"
			[class.ficon-folder-open]="isExpanded()"
			[class.ficon-folder-filled]="!isExpanded()">
		</i>
		<span class="collection-folder-name" [id]="getTreeGridNameElementId()">
			{{folder.name}}
		</span>
	</div>
</th>
<td
	role="gridcell"
	class="library-tree-cell library-tree-cell-modified"
	data-tree-cell="modified"
	[attr.headers]="treeGridModifiedHeaderId"
	[attr.aria-labelledby]="getTreeGridModifiedLabelledBy()"
	[attr.tabindex]="treeGridModifiedTabindex"
	(focus)="emitTreeGridFocus('modified')"
	(keydown)="emitTreeGridKeydown($event, 'modified')"
	(click)="expandFolder(folder)">
	<span class="collection-folder-modified-date" [id]="getTreeGridModifiedElementId()">
		{{ formatDate(folder.updated_at) }}
	</span>
</td>
<td role="gridcell" class="library-tree-cell library-tree-cell-actions">
	@if (!multiSelect && managedCollectionAccess()) {
		<button
			type="button"
			[matMenuTriggerFor]="rowMenu"
			data-tree-row-action
			data-tree-cell="actions"
			[attr.tabindex]="treeGridActionTabindex"
			data-cy="collection-folder-menu"
			class="btn-none collection-folder-menu folder-options-dropdown-menu"
			[attr.aria-label]="getMenuAriaLabel()"
			(focus)="emitTreeGridFocus('actions')"
			(keydown)="emitTreeGridKeydown($event, 'actions')"
			(click)="$event.stopPropagation()">
			<i class="ficon-app-dots-vertical"></i>
		</button>
		<mat-menu #rowMenu="matMenu">
			<button
				mat-menu-item
				class="edit-folder-button"
				type="button"
				data-cy="common-rename"
				(click)="openEditFolderModal()">
				<span translate="common_rename"></span>
			</button>
			<button
				mat-menu-item
				class="remove-option"
				type="button"
				data-cy="common-remove"
				(click)="removeFolder(folder)">
				<span translate="common_remove"></span>
			</button>
		</mat-menu>
	}
</td>
